class SearchForm extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector('input[type="search"]');
    this.resetButton = this.querySelector('button[type="reset"]');

    if (this.input) {
      this.input.form.addEventListener('reset', this.onFormReset.bind(this));
      this.input.addEventListener(
        'input',
        debounce((event) => {
          this.onChange(event);
        }, 300).bind(this)
      );
    }
  }

  toggleResetButton() {
    const resetIsHidden = this.resetButton.classList.contains('hidden');
    if (this.input.value.length > 0 && resetIsHidden) {
      this.resetButton.classList.remove('hidden');
    } else if (this.input.value.length === 0 && !resetIsHidden) {
      this.resetButton.classList.add('hidden');
    }
  }

  onChange() {
    this.toggleResetButton();
  }

  shouldResetForm() {
    return !document.querySelector('[aria-selected="true"] a');
  }

  onFormReset(event) {
    // Prevent default so the form reset doesn't set the value gotten from the url on page load
    event.preventDefault();
    // Don't reset if the user has selected an element on the predictive search dropdown
    if (this.shouldResetForm()) {
      this.input.value = '';
      this.input.focus();
      this.toggleResetButton();
    }
  }
}

customElements.define('search-form', SearchForm);
// PowerPrint: storefront search = PRODUCTS ONLY + PRODUCT TITLE ONLY
document.addEventListener(
  'submit',
  function (event) {
    const form = event.target;

    if (!(form instanceof HTMLFormElement)) return;

    const action = form.getAttribute('action') || '';

    // Only affect Shopify search forms
    if (!action.includes('/search')) return;

    const input = form.querySelector('input[name="q"]');
    if (!input) return;

    const searchTerm = input.value.trim();
    if (!searchTerm) return;

    // Don't process it twice
    if (searchTerm.startsWith('title:')) return;

    // Require every searched word to exist in the PRODUCT TITLE
    const titleOnlyQuery = searchTerm
      .split(/\s+/)
      .filter(Boolean)
      .map((word) => {
        const safeWord = word
          .replace(/\\/g, '\\\\')
          .replace(/"/g, '\\"');

        return `title:"${safeWord}"`;
      })
      .join(' ');

    input.value = titleOnlyQuery;

    // Force Shopify to return PRODUCTS ONLY
    let typeInput = form.querySelector('input[name="type"]');

    if (!typeInput) {
      typeInput = document.createElement('input');
      typeInput.type = 'hidden';
      typeInput.name = 'type';
      form.appendChild(typeInput);
    }

    typeInput.value = 'product';
  },
  true
);